import {
  Card,
  CardContent,
  CardHeader,
  Container,
  Typography,
} from "@mui/material";
import { ReactElement } from "react";

export default function FullPageCard({
  title,
  children,
}: {
  title: React.ReactNode;
  children: React.ReactNode;
}): ReactElement {
  return (
    <Container maxWidth="sm" sx={{ marginTop: 8 }}>
      <Card>
        <CardHeader
          sx={{ p: 2 }}
          title={<Typography variant="h2">{title}</Typography>}
        />

        <CardContent>{children}</CardContent>
      </Card>
    </Container>
  );
}
